export default "__VITE_ASSET__ZbJkRXXM__"